import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IStaffProfile, IStaffProfileListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export interface IStaffProfileListQuery {
  staffType?: string;
  cityId?: string;
  status?: string;
  search?: string;
}

export const useStaffProfileListAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [staffList, setStaffList] = useState<IStaffProfile[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const execute = useCallback(
    async ({ staffType = "", cityId = "", status = "", search = "" }: IStaffProfileListQuery = {}) => {
      setIsLoading(true);
      setHasError(false);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const params = new URLSearchParams();
        if (staffType) params.append("staff_type", staffType);
        if (cityId) params.append("city_id", cityId);
        if (status) params.append("status", status);
        if (search) params.append("search", search);

        const query = params.toString();
        const response = await axios.get<IStaffProfileListResponse>(
          `${CONFIGURATION_APIS.STAFF_PROFILE_LIST.baseURL}${query ? `?${query}` : ""}`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        setStaffList(response.data?.data ?? []);
      } catch (error) {
        setStaffList([]);
        setHasError(true);
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          captureError(axiosError);
          if (axiosError.config) {
            sendCurl(axiosError.config["curlCommand"]);
          }
        }
      } finally {
        setIsLoading(false);
      }
    },
    [configuration],
  );

  return { execute, staffList, isLoading, hasError };
};
